export default "__VITE_ASSET__Bz6iLK8R__"